import { VuexPersistence } from 'vuex-persist'

export default ({ store }) => {
  new VuexPersistence({
    modules: ['userProfile','selectedFilter']
  }).plugin(store);
}
